// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__6lU_2","alertIcon":"ConfirmModal_alertIcon__LRzDL"};